import React from 'react';
import styles from './MobileHeader.module.scss';
import { IconMenu } from '@justeattakeaway/pie-icons-react';
import TakeAwayLogo from '@assets/tkwylogo.svg';
import { globalStyles } from 'snacks-design-system';
import SlideInOut from '@src/shared/animations/SlideInOut';
import MobilePageTitle from '../../../MobilePageTitle';
import { useMobileViewState } from '@src/shared/context/mobile-view';
import { NavLink } from 'react-router-dom';
import LanguageSelector from '@src/shared/components/LanguageSelector';
import HeaderNotificationIndicator from '../HeaderNotificationIndicator';
import UserLogo from '@src/shared/components/UserLogo';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { IHeaderVariantProps } from '../..';
import PWAAppScreens from '@src/shared/components/PWAAppScreens';
import { useOnboardingStore } from '@src/shared/store/onboarding/onboarding-store';
const { xdsColorInteractiveBrand, xdsSpacingE } = globalStyles;

const MobileHeader = ({
  fixed,
  onShowMenu,
  onShowNotificationMenu,
  onShowUserMenu,
  onShowLanguageMenu,
  showUserPanel,
  showLanguageSelector,
  loading,
  notificationCount,
  showNotification,
}: IHeaderVariantProps) => {
  const { showHeaderPageReferenceText } = useMobileViewState();

  const { onboardingActive } = useOnboardingStore();

  const renderCenterContent = () => {
    return !showHeaderPageReferenceText ? (
      <NavLink to="/deliveries">
        <img className={styles.logo} src={TakeAwayLogo} />
      </NavLink>
    ) : (
      <SlideInOut variant="in">
        <MobilePageTitle currentPath={location.pathname} />
      </SlideInOut>
    );
  };

  return (
    <>
      {!onboardingActive && <PWAAppScreens />}
      <div className={`${styles.PortalMobileHeader} ${fixed ? styles.fixed : ''}`}>
        <IconMenu size={'s'} color={xdsColorInteractiveBrand} onClick={onShowMenu} />
        <div className={styles.placeCenter}>{renderCenterContent()}</div>
        <div className={styles.rightContainer}>
          {showNotification && (
            <PIEComponentUtil marginRight={xdsSpacingE}>
              <HeaderNotificationIndicator
                loading={loading}
                counter={notificationCount}
                onClick={onShowNotificationMenu}
              />
            </PIEComponentUtil>
          )}
          {showUserPanel && <UserLogo onClick={onShowUserMenu} />}
          {showLanguageSelector && (
            <LanguageSelector
              onClick={onShowLanguageMenu}
              toggleButtonClass={''}
              showToggleButton={true}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MobileHeader;
